module.exports = __webpack_public_path__ + "img/video_icon11.11a08ae8.png";